(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-five-elements-quiz"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hb-five-elements-quiz')) {
  customElements.define('hb-five-elements-quiz', class extends HTMLElement {
    connectedCallback() {
      if (this.hbqAbort) return;
      this.hbqAbort = new AbortController();
      const signal = this.hbqAbort.signal;
      const listen = (target, type, callback, options = {}) => target.addEventListener(type, callback, { ...options, signal });
      this.hbqCards = Array.from(this.querySelectorAll('[data-hbq-index]'));
      this.hbqDots = Array.from(this.querySelectorAll('[data-hbq-go]'));
      this.hbqStage = this.querySelector('.hbq-stage');
      if (!this.hbqCards.length || !this.hbqStage) return;
      this.hbqActive = 0;
      this.hbqDetailIndex = null;
      this.hbqPointer = null;
      this.hbqSuppressClickUntil = 0;
      this.hbqHoverUntil = 0;
      this.hbqHoverPoint = null;
      this.hbqFoodRequested = false;
      this.hbqFoodStates = this.hbqCards.map(() => ({ ready: false, loading: false, failed: false, image: null }));
      this.hbqHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.hbqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.hbqDesktop = window.matchMedia('(min-width: 750px)');
      this.hbqSetSizes();
      this.setAttribute('data-hbq-ready', '');
      this.hbqUpdateFoods();
      this.hbqRender(true);

      this.hbqResize = new ResizeObserver(() => {
        this.hbqSetSizes();
        this.hbqRender(true);
      });
      this.hbqResize.observe(this.hbqStage);
      listen(this.hbqDesktop, 'change', () => { this.hbqSetSizes(); this.hbqRender(true); });
      listen(this.hbqStage, 'focusin', event => {
        const card = event.target.closest('[data-hbq-index]');
        if (card && card.matches(':focus-visible')) this.hbqSelect(Number(card.dataset.hbqIndex), true);
      });
      listen(this, 'click', event => {
        if (Date.now() < this.hbqSuppressClickUntil) { event.preventDefault(); event.stopPropagation(); return; }
        const card = event.target.closest('[data-hbq-index]');
        const dot = event.target.closest('[data-hbq-go]');
        const direction = event.target.closest('[data-hbq-direction]');
        if (card) this.hbqSelect(Number(card.dataset.hbqIndex), true);
        else if (dot) this.hbqSelect(Number(dot.dataset.hbqGo));
        else if (direction) this.hbqSelect(this.hbqActive + Number(direction.dataset.hbqDirection));
      }, { capture: true });
      listen(this.querySelector('.hbq-gallery'), 'keydown', event => {
        const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (!keys.includes(event.key)) return;
        event.preventDefault();
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? this.hbqCards.length - 1 : this.hbqActive + (event.key === 'ArrowRight' ? 1 : -1);
        this.hbqSelect(target);
        if (event.target.closest('[data-hbq-index]')) this.hbqCards[this.hbqActive].focus({ preventScroll: true });
      });
      listen(this.hbqStage, 'dragstart', event => event.preventDefault());
      listen(this.hbqStage, 'pointerdown', event => {
        if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
        this.hbqPointer = { id: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, horizontal: false };
      });
      listen(this.hbqStage, 'pointermove', event => {
        const pointer = this.hbqPointer;
        if (!pointer) {
          if (event.pointerType !== 'mouse' || !this.hbqHover.matches || event.buttons || Date.now() < this.hbqHoverUntil) return;
          const card = event.target.closest('[data-hbq-index]');
          if (!card || card.getAttribute('aria-hidden') === 'true') return;
          const point = this.hbqHoverPoint;
          if (point && Math.hypot(event.clientX - point.x, event.clientY - point.y) < 5) return;
          const index = Number(card.dataset.hbqIndex);
          if (index !== this.hbqActive || !this.hbqFoodRequested) {
            this.hbqHoverPoint = { x: event.clientX, y: event.clientY };
            this.hbqSelect(index, true);
          }
          return;
        }
        if (pointer.id !== event.pointerId) return;
        const dx = event.clientX - pointer.x;
        const dy = event.clientY - pointer.y;
        if (!pointer.horizontal) {
          if (Math.abs(dy) > 10 && Math.abs(dy) >= Math.abs(dx)) { this.hbqPointer = null; return; }
          if (Math.abs(dx) < 10 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
          pointer.horizontal = true;
          this.setAttribute('data-hbq-dragging', '');
          this.hbqStage.setPointerCapture(event.pointerId);
        }
        pointer.dx = dx;
        if (event.cancelable) event.preventDefault();
        this.hbqStage.style.setProperty('--hbq-drag', Math.max(-this.hbqStep, Math.min(this.hbqStep, dx)) + 'px');
      });
      const finishSwipe = event => {
        const pointer = this.hbqPointer;
        if (!pointer || pointer.id !== event.pointerId) return;
        if (event.type === 'lostpointercapture' && event.target !== this.hbqStage) return;
        this.hbqPointer = null;
        this.removeAttribute('data-hbq-dragging');
        this.hbqStage.style.setProperty('--hbq-drag', '0px');
        if (this.hbqStage.hasPointerCapture(event.pointerId)) this.hbqStage.releasePointerCapture(event.pointerId);
        if (pointer.horizontal) {
          this.hbqSuppressClickUntil = Date.now() + 300;
          if (event.type === 'pointerup' && Math.abs(pointer.dx) > 28) this.hbqSelect(this.hbqActive + (pointer.dx < 0 ? 1 : -1));
        }
      };
      listen(this.hbqStage, 'pointerup', finishSwipe);
      listen(this.hbqStage, 'pointercancel', finishSwipe);
      listen(this.hbqStage, 'lostpointercapture', finishSwipe);
      listen(document, 'shopify:block:select', event => {
        const card = event.target.closest('[data-hbq-index]');
        if (card && this.contains(card)) this.hbqSelect(Number(card.dataset.hbqIndex));
      });
    }

    hbqSetSizes() {
      const width = this.hbqStage.clientWidth;
      const desktop = this.hbqDesktop.matches;
      this.hbqCardWidth = desktop ? Math.min(178, (width - 80) / 5) : (width - 30) / 3;
      this.hbqStep = this.hbqCardWidth + (desktop ? 18 : 10);
      this.hbqStage.style.setProperty('--hbq-card-width', this.hbqCardWidth + 'px');
      this.hbqStage.style.setProperty('--hbq-stage-height', Math.ceil(this.hbqCardWidth * 5 / 3 + (desktop ? 118 : 64)) + 'px');
    }

    hbqSelect(index, revealFood = false) {
      const count = this.hbqCards.length;
      const next = ((index % count) + count) % count;
      const changed = next !== this.hbqActive;
      this.hbqFoodRequested = revealFood;
      this.hbqHoverUntil = Date.now() + (this.hbqReduced.matches ? 120 : 550);
      this.hbqActive = next;
      if (revealFood) this.hbqLoadFood(next);
      if (changed) this.hbqRender(false);
      this.hbqUpdateFoods();
      this.hbqUpdateDetail();
    }

    hbqLoadFood(index) {
      const card = this.hbqCards[index];
      const state = this.hbqFoodStates[index];
      if (state.ready || state.loading || !card.dataset.hbqFoodSrc) return;
      state.loading = true;
      state.failed = false;
      const image = new Image();
      state.image = image;
      image.decoding = 'async';
      image.addEventListener('load', () => {
        if (!this.isConnected) return;
        state.loading = false;
        state.ready = true;
        card.querySelector('.hbq-food-photo').style.backgroundImage = 'url(' + JSON.stringify(image.currentSrc || image.src) + ')';
        this.hbqUpdateFoods();
      }, { once: true, signal: this.hbqAbort.signal });
      image.addEventListener('error', () => {
        if (!this.isConnected) return;
        state.loading = false;
        state.failed = true;
        this.hbqUpdateFoods();
      }, { once: true, signal: this.hbqAbort.signal });
      image.sizes = Math.ceil(this.hbqCardWidth * 1.04) + 'px';
      if (card.dataset.hbqFoodSrcset) image.srcset = card.dataset.hbqFoodSrcset;
      image.src = card.dataset.hbqFoodSrc;
    }

    hbqUpdateFoods() {
      this.hbqCards.forEach((card, index) => {
        const food = this.hbqFoodStates[index];
        const revealed = food.ready && this.hbqFoodRequested && index === this.hbqActive;
        card.toggleAttribute('data-hbq-food-revealed', revealed);
        const state = revealed ? 'Foods shown: ' + card.dataset.hbqFoodNames + '.' : food.failed ? 'Food image unavailable. Select again to retry.' : 'Reveal foods.';
        card.setAttribute('aria-label', 'Explore ' + card.dataset.hbqName + ', ' + card.dataset.hbqSeason + '. ' + state);
      });
    }

    hbqRender(immediate) {
      const count = this.hbqCards.length;
      const desktop = this.hbqDesktop.matches;
      this.hbqCards.forEach((card, index) => {
        let slot = ((index - this.hbqActive) % count + count) % count;
        if (slot > Math.floor(count / 2)) slot -= count;
        const distance = Math.abs(slot);
        const hidden = !desktop && distance > 1;
        const oldSlot = Number(card.dataset.hbqSlot);
        const wrapping = !immediate && Number.isFinite(oldSlot) && Math.abs(slot - oldSlot) > count / 2;
        if (wrapping || immediate) card.classList.add('hbq-is-wrapping');
        card.dataset.hbqSlot = String(slot);
        card.style.setProperty('--hbq-x', slot * this.hbqStep + 'px');
        card.style.setProperty('--hbq-y', (desktop ? distance * distance * 10 : distance * 10) + 'px');
        card.style.setProperty('--hbq-angle', slot * (desktop ? 3.5 : 4) + 'deg');
        card.style.setProperty('--hbq-scale', distance === 0 ? '1.04' : distance === 1 ? '.91' : '.8');
        card.style.setProperty('--hbq-z', String(3 - distance));
        card.style.setProperty('--hbq-opacity', hidden ? '0' : '1');
        card.setAttribute('aria-pressed', String(index === this.hbqActive));
        card.setAttribute('aria-hidden', String(hidden));
        card.tabIndex = hidden ? -1 : 0;
        if (wrapping || immediate) requestAnimationFrame(() => requestAnimationFrame(() => { if (card.isConnected) card.classList.remove('hbq-is-wrapping'); }));
      });
      this.hbqDots.forEach((dot, index) => dot.setAttribute('aria-pressed', String(index === this.hbqActive)));
      if (immediate) this.hbqUpdateDetail();
    }

    hbqUpdateDetail() {
      if (this.hbqDetailIndex === this.hbqActive) return;
      this.hbqDetailIndex = this.hbqActive;
      const card = this.hbqCards[this.hbqActive];
      this.querySelector('[data-hbq-detail-name]').textContent = card.dataset.hbqName;
      this.querySelector('[data-hbq-detail-season]').textContent = card.dataset.hbqSeason;
      this.querySelector('[data-hbq-detail-description]').textContent = card.dataset.hbqDescription;
      const foods = this.querySelector('[data-hbq-detail-foods]');
      const template = this.querySelector('[data-hbq-foods-template="' + this.hbqActive + '"]');
      if (template) foods.replaceChildren(template.content.cloneNode(true));
      else foods.replaceChildren();
    }

    disconnectedCallback() {
      this.hbqAbort?.abort();
      this.hbqAbort = null;
      this.hbqResize?.disconnect();
      this.hbqFoodStates = [];
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-sources"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hb-sources')) {
  customElements.define('hb-sources', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.tabs = Array.from(this.querySelectorAll('.source-tab'));
      this.panels = Array.from(this.querySelectorAll('.source-panel'));
      this.addEventListener('click', event => {
        const tab = event.target.closest('.source-tab');
        if (tab && this.tabs.includes(tab)) this.selectTab(tab);
      }, options);
      this.addEventListener('keydown', event => {
        const tab = event.target.closest('.source-tab');
        const index = this.tabs.indexOf(tab);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.selectTab(this.tabs[next], true);
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const tab = this.tabs.find(item => item.dataset.sourceBlockId === event.detail?.blockId);
        if (tab) this.selectTab(tab);
      }, options);
    }
    selectTab(tab, focus = false) {
      if (!tab || !this.tabs.includes(tab)) return;
      const selectedPanelId = tab.getAttribute('aria-controls');
      this.tabs.forEach(item => {
        const selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach(panel => {
        const selected = panel.id === selectedPanelId;
        panel.hidden = !selected;
        panel.classList.toggle('changing', selected);
      });
      if (focus) tab.focus();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.tabs = [];
      this.panels = [];
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
if (!customElements.get('hb-navigation')) {
  class HerbloomNavigation extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('header');
      this.toggle = this.header.querySelector('.hb-menu-toggle');
      this.groups = [...this.querySelectorAll('.hb-group-toggle')];
      this.mobile = window.matchMedia('(max-width: 989px)');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const listen = (target, name, action, options = {}) => target.addEventListener(name, action, { ...options, signal: this.abort.signal });
      this.categoryButtons = [...this.querySelectorAll('.hb-category-toggle')];
      this.featured = this.querySelector('[data-hb-featured]');
      this.desktopContent = this.querySelector('[data-hb-desktop-content]');
      this.placeCategories();
      listen(this.toggle, 'click', () => this.open ? this.closeMobile() : this.openMobile());
      this.categoryButtons.forEach(button => {
        listen(button, 'click', () => {
          clearTimeout(this.leaveTimer);
          const wasOpen = button.getAttribute('aria-expanded') === 'true';
          this.categoryButtons.forEach(other => {
            const active = other === button && !wasOpen;
            other.setAttribute('aria-expanded', String(active));
            this.panelFor(other).hidden = !active;
          });
          this.syncFeatured();
        });
        listen(button, 'keydown', event => {
          if (!this.mobile.matches && event.key === 'ArrowRight') {
            event.preventDefault();
            if (button.getAttribute('aria-expanded') !== 'true') button.click();
            this.panelFor(button).querySelector('a')?.focus();
          }
        });
        listen(this.panelFor(button), 'keydown', event => {
          if (!this.mobile.matches && event.key === 'ArrowLeft') {
            event.preventDefault(); button.focus();
          }
        });
      });
      this.groups.forEach(button => {
        const panel = this.panelFor(button);
        listen(button, 'click', event => {
          clearTimeout(this.hoverTimer); clearTimeout(this.leaveTimer);
          const closeFromKeyboard = !this.mobile.matches && event.detail === 0 && button.getAttribute('aria-expanded') === 'true';
          this.showGroup(closeFromKeyboard ? null : button);
        });
        listen(button, 'keydown', event => {
          if (!this.mobile.matches && event.key === 'ArrowDown') {
            event.preventDefault(); this.showGroup(button); panel.querySelector('a')?.focus();
          }
        });
        listen(button, 'pointerenter', event => {
          clearTimeout(this.leaveTimer);
          if (!this.mobile.matches && event.pointerType === 'mouse') this.hoverTimer = setTimeout(() => this.showGroup(button), 100);
        });
        listen(button, 'pointerleave', () => clearTimeout(this.hoverTimer));
        listen(panel, 'pointerenter', () => clearTimeout(this.leaveTimer));
      });
      listen(this.querySelector('.hb-nav-link'), 'pointerenter', () => { if (!this.mobile.matches) this.showGroup(null); });
      listen(this.header, 'pointerenter', () => clearTimeout(this.leaveTimer));
      listen(this.header, 'pointerleave', event => {
        if (!this.mobile.matches && event.pointerType === 'mouse') this.leaveTimer = setTimeout(() => this.showGroup(null), 200);
      });
      listen(this.header, 'focusout', event => {
        const next = event.relatedTarget;
        if (!this.mobile.matches && next && next !== document.body && next !== document.documentElement && !this.header.contains(next)) this.showGroup(null);
      });
      listen(this.header, 'click', event => {
        if (event.target.closest('a,.hb-search summary')) {
          if (this.open) this.closeMobile(false, true);
          this.showGroup(null);
        }
      }, { capture: true });
      listen(document, 'pointerdown', event => { if (!this.header.contains(event.target)) this.showGroup(null); });
      listen(document, 'keydown', event => this.keydown(event));
      listen(this.mobile, 'change', () => { this.closeMobile(false, true); this.showGroup(null); this.resetCategories(); this.placeCategories(); });
      listen(window, 'resize', () => { if (this.open) this.position(); });
      listen(window, 'pagehide', () => this.closeMobile(false, true));
      this.ink = createHerbloomNavInk(this, listen);
      this.shopAllInk = createHerbloomNavInk(this, listen, '.hb-shop-all-wrap', '.hb-shop-all');
      listen(document, 'shopify:block:select', event => {
        const selected = [...this.querySelectorAll('[data-hb-block-id]')].find(node => node.dataset.hbBlockId === event.detail.blockId);
        if (!selected) return;
        if (this.mobile.matches && !this.open) this.openMobile();
        this.showGroup(selected.closest('.hb-about-panel') ? this.groups[1] : this.groups[0]);
        const categoryId = selected.dataset.hbCategoryId;
        this.categoryButtons.forEach(button => {
          const active = Boolean(categoryId && button.dataset.hbCategoryId === categoryId);
          button.setAttribute('aria-expanded', String(active));
          this.panelFor(button).hidden = !active;
        });
        this.syncFeatured();
        selected.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      });
    }
    position() {
      this.style.setProperty('--hb-menu-top', `${Math.max(0,this.header.getBoundingClientRect().bottom)}px`);
    }
    panelFor(button) {
      return document.getElementById(button.getAttribute('aria-controls'));
    }
    showGroup(selected) {
      if (selected && selected.getAttribute('aria-expanded') !== 'true') this.resetCategories();
      this.groups.forEach(button => {
        const active = button === selected;
        button.setAttribute('aria-expanded', String(active));
        this.panelFor(button).hidden = !active;
      });
    }
    resetCategories() {
      this.categoryButtons.forEach(button => {
        button.setAttribute('aria-expanded','false'); this.panelFor(button).hidden = true;
      });
      this.syncFeatured();
    }
    placeCategories() {
      this.categoryButtons.forEach(button => {
        const panel = this.panelFor(button);
        if (this.mobile.matches) button.after(panel);
        else this.desktopContent.append(panel);
      });
      this.syncFeatured();
    }
    syncFeatured() {
      this.featured.hidden = !this.mobile.matches && this.categoryButtons.some(button => button.getAttribute('aria-expanded') === 'true');
    }
    openMobile() {
      if (!this.mobile.matches) return;
      clearTimeout(this.closeTimer);
      this.position(); this.open = true;
      this.classList.remove('hb-leaving'); this.classList.add('hb-visible');
      this.toggle.setAttribute('aria-expanded','true'); this.toggle.setAttribute('aria-label','Close menu');
      this.header.setAttribute('role','dialog'); this.header.setAttribute('aria-modal','true'); this.header.setAttribute('aria-label','Main menu');
      this.oldOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.inertNodes = [];
      let node = this.header;
      while (node.parentElement && node !== document.body) {
        [...node.parentElement.children].forEach(sibling => {
          if (sibling !== node && !sibling.inert && !['SCRIPT','STYLE','LINK'].includes(sibling.tagName)) { sibling.inert = true; this.inertNodes.push(sibling); }
        });
        node = node.parentElement;
      }
      this.resetCategories(); this.showGroup(this.groups[0]);
      this.toggle.focus({preventScroll:true});
    }
    closeMobile(focus = true, immediate = false) {
      if (!this.open) return;
      this.open = false;
      this.toggle.setAttribute('aria-expanded','false'); this.toggle.setAttribute('aria-label','Open menu');
      this.header.removeAttribute('role'); this.header.removeAttribute('aria-modal'); this.header.removeAttribute('aria-label');
      (this.inertNodes || []).forEach(node => { node.inert = false; }); this.inertNodes = [];
      document.body.style.overflow = this.oldOverflow || '';
      const finish = () => { this.classList.remove('hb-visible','hb-leaving'); if (this.mobile.matches) this.showGroup(null); };
      if (immediate || this.reduced.matches) finish();
      else { this.classList.add('hb-leaving'); this.closeTimer = setTimeout(finish,150); }
      if (focus) this.toggle.focus({preventScroll:true});
    }
    keydown(event) {
      if (event.key === 'Escape') {
        if (this.open) { event.preventDefault(); this.closeMobile(); }
        else if (!this.mobile.matches) {
          const current = this.querySelector('.hb-group-toggle[aria-expanded="true"]');
          if (current) { event.preventDefault(); this.showGroup(null); current.focus(); }
        }
      }
      if (event.key !== 'Tab' || !this.open) return;
      const focusable = [...this.header.querySelectorAll('a[href],button:not([disabled]),summary')].filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
    disconnectedCallback() {
      this.closeMobile(false,true); this.ink?.destroy(); this.shopAllInk?.destroy(); this.abort?.abort(); clearTimeout(this.hoverTimer); clearTimeout(this.leaveTimer); clearTimeout(this.closeTimer);
    }
  }
  customElements.define('hb-navigation', HerbloomNavigation);
}

function createHerbloomNavInk(host, listen, rootSelector = '.hb-nav-tabs', buttonSelector = '.hb-group-toggle, .hb-nav-link') {
  const root = host.querySelector(rootSelector);
  const canvas = root?.querySelector('canvas');
  const ctx = canvas?.getContext('2d');
  if (!ctx) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const items = Array.from(root.querySelectorAll(buttonSelector)).map(button => ({
    button, selected:false, hover:false, focused:false, held:false, until:0,
    level:0, spread:0, border:.70, x:.5, targetX:.5,
    cx:0, cy:0, width:0, height:0
  }));
  let width=0, height=0, dpr=1, raf=0, previous=0, destroyed=false;
  function schedule() {
    if (!raf && !destroyed && root.isConnected) raf=requestAnimationFrame(render);
  }
  function framePath(x,y,w,h) {
    const l=x-w/2, r=x+w/2, t=y-h/2, b=y+h/2, u=4.2;
    ctx.beginPath();
    ctx.moveTo(l+u,t); ctx.lineTo(r-u,t);
    ctx.moveTo(l+u,b); ctx.lineTo(r-u,b);
    ctx.moveTo(l+u,t+u); ctx.lineTo(l,t+u); ctx.lineTo(l,b-u); ctx.lineTo(l+u,b-u);
    ctx.moveTo(r-u,t+u); ctx.lineTo(r,t+u); ctx.lineTo(r,b-u); ctx.lineTo(r-u,b-u);
    for (const [cx,cy,sx,sy] of [[l,t,1,1],[r,t,-1,1],[r,b,-1,-1],[l,b,1,-1]]) {
      [[1,0],[1,2],[2.75,2],[2.75,1],[1.875,1],[1.875,1.5]].forEach(([px,py],i) => {
        const px2=cx+px*u*sx, py2=cy+py*u*sy;
        if (i===0) ctx.moveTo(px2,py2); else ctx.lineTo(px2,py2);
      });
    }
  }
  function draw(item) {
    const {width:w,height:h,cx,cy}=item;
    if (!w || !h) return;
    const strength=item.level;
    if (strength>.001) {
      const expansion=reduced.matches ? 0 : item.spread*(w<100 ? 2 : 3.5);
      const blur=reduced.matches ? 3 : 2.5+6.5*item.spread;
      const wash=ctx.createLinearGradient(cx-w/2,cy-h*.35,cx+w/2,cy+h*.35);
      wash.addColorStop(0,`rgba(243,244,187,${strength*.37})`);
      wash.addColorStop(Math.max(.15,Math.min(.85,item.x)),`rgba(188,197,74,${strength*.40})`);
      wash.addColorStop(1,`rgba(243,244,187,${strength*.30})`);
      ctx.save();
      if ('filter' in ctx) ctx.filter=`blur(${blur.toFixed(2)}px)`;
      else { ctx.shadowColor=`rgba(188,197,74,${strength*.24})`; ctx.shadowBlur=blur; }
      ctx.strokeStyle=wash;
      ctx.lineWidth='filter' in ctx ? 5+item.spread*4 : 1.5;
      ctx.lineJoin='round'; ctx.lineCap='round';
      framePath(cx,cy,w-2+expansion,h-4+expansion);
      ctx.stroke();
      ctx.restore();
    }
    ctx.strokeStyle=`rgba(119,126,66,${item.border.toFixed(3)})`;
    ctx.lineWidth=0.8625; ctx.lineJoin='round'; ctx.lineCap='round';
    framePath(cx,cy,w-2,h-4);
    ctx.stroke();
  }
  function approach(value,target,dt,tau) {
    const next=value+(target-value)*(1-Math.exp(-dt/tau));
    return Math.abs(next-target)<.001 ? target : next;
  }
  function render(now) {
    raf=0;
    if (destroyed || !root.isConnected) return;
    const dt=previous ? Math.min(40,Math.max(1,now-previous)) : 16;
    previous=now;
    ctx.setTransform(dpr,0,0,dpr,0,0);
    ctx.clearRect(0,0,width,height);
    let moving=false;
    for (const item of items) {
      const pressed=item.held || now<item.until;
      const hovering=item.hover || item.focused;
      const target=pressed ? 1 : hovering ? .34 : 0;
      const borderTarget=item.selected || pressed ? 1 : hovering ? .88 : .70;
      if (reduced.matches) { item.level=target; item.spread=target; item.border=borderTarget; }
      else {
        item.level=approach(item.level,target,dt,target>item.level ? (pressed ? 38 : 78) : 160);
        item.spread=approach(item.spread,target,dt,target>item.spread ? 110 : 220);
        item.border=approach(item.border,borderTarget,dt,85);
      }
      item.x=approach(item.x,item.targetX,dt,115);
      draw(item);
      moving ||= item.level!==target || item.spread!==target || item.border!==borderTarget || item.x!==item.targetX || now<item.until;
    }
    if (moving) schedule(); else previous=0;
  }
  function sync() {
    const opened=items.find(item=>item.button.getAttribute('aria-expanded')==='true');
    for (const item of items) item.selected=opened ? item===opened : item.button.getAttribute('aria-current')==='page';
    schedule();
  }
  function resize() {
    const bounds=canvas.getBoundingClientRect();
    width=bounds.width; height=bounds.height;
    dpr=Math.min(window.devicePixelRatio || 1,2);
    canvas.width=Math.round(width*dpr); canvas.height=Math.round(height*dpr);
    for (const item of items) {
      const rect=item.button.getBoundingClientRect();
      item.width=rect.width; item.height=rect.height;
      item.cx=rect.left-bounds.left+rect.width/2; item.cy=rect.top-bounds.top+rect.height/2;
    }
    schedule();
  }
  function point(item,event) {
    const box=item.button.getBoundingClientRect();
    item.targetX=Math.max(0,Math.min(1,(event.clientX-box.left)/box.width));
  }
  const observer=new ResizeObserver(resize);
  const attributes=new MutationObserver(sync);
  observer.observe(root);
  items.forEach(item => {
    const button=item.button;
    observer.observe(button);
    attributes.observe(button,{attributes:true,attributeFilter:['aria-expanded','aria-current']});
    listen(button,'pointerenter',event => {
      if (event.pointerType==='touch') return;
      item.hover=true; point(item,event); schedule();
    });
    listen(button,'pointermove',event => {
      if (event.pointerType==='touch') return;
      point(item,event); schedule();
    });
    listen(button,'pointerleave',() => { item.hover=false; item.held=false; schedule(); });
    listen(button,'pointerdown',event => { item.held=true; point(item,event); schedule(); });
    listen(button,'pointerup',() => { item.held=false; schedule(); });
    listen(button,'pointercancel',() => { item.held=false; item.hover=false; item.until=0; schedule(); });
    listen(button,'focus',() => { item.focused=button.matches(':focus-visible'); schedule(); });
    listen(button,'blur',() => { item.focused=false; item.held=false; schedule(); });
    listen(button,'click',event => {
      if (!event.detail) item.targetX=.5;
      item.held=false; item.until=performance.now()+120; sync();
    });
  });
  listen(reduced,'change',schedule);
  listen(window,'blur',() => {
    for (const item of items) { item.held=false; item.hover=false; item.until=0; }
    schedule();
  });
  sync(); resize();
  return { destroy() { destroyed=true; cancelAnimationFrame(raf); observer.disconnect(); attributes.disconnect(); } };
}

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    const marginDesktopValue = this.getAttribute('data-margin-desktop');
    // Fetch data-margin-desktop and calculate percentage
    this.marginDesktopPercentage = parseFloat(marginDesktopValue) || 2; 
    this.marginDesktopThreshold = this.marginDesktopPercentage*2 / 100; 

    const marginMobileValue = this.getAttribute('data-margin-mobile');
    this.marginMobilePercentage = parseFloat(marginMobileValue) || 2; 
    this.marginMobileThreshold = this.marginMobilePercentage / 300; 

    this.viewportQuery = window.matchMedia('(max-width: 990px)');
    this.onViewportChange = this.setHeaderHeight.bind(this);
    this.viewportQuery.addEventListener('change', this.onViewportChange);

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    this.viewportQuery.removeEventListener('change', this.onViewportChange);
    this.boundsObserver?.disconnect();
    clearTimeout(this.isScrolling);
  }

  createObserver() {
    this.boundsObserver = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    this.boundsObserver.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 250; 
    const viewportWidth = window.innerWidth;
    let resetOffset;

    if (viewportWidth < 990) {
      resetOffset = window.innerHeight * this.marginMobileThreshold;
    } else {
      // Using desktop threshold
      resetOffset = window.innerHeight * this.marginDesktopThreshold;
    }

    if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top + resetOffset) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden');
    this.header.classList.remove('shopify-section-header-sticky');
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

}

customElements.define('sticky-header', StickyHeader);

  function initIntersectionObserver() {
  const headers = document.querySelectorAll('.enable-fixed-header-part--true.enable-header-full-width--false');

  if (!headers.length) return; // Ensure there are elements to observe

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target); 
      }
    });
  }, { threshold: 1 });

  headers.forEach(header => {
    observer.observe(header);
  });
}

initIntersectionObserver();

document.addEventListener('shopify:section:load', () => {
  initIntersectionObserver();
});


  } catch(e) { console.error(e); }
})();
})();
